import React, { Component } from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import ReactPlayer from 'react-player'

import Waypoint from 'react-waypoint';
import styled from "react-emotion";

const Revealable = styled("div")`
  opacity: ${({ show }) => (show ? "100" : "0")};
  margin-top: ${({ show }) => (show ? "0" : "100px")};
  transition: opacity ease-out 0.5s, margin-top cubic-bezier(0, 0, 0.58, 1) 1s;`;

class Reveal extends Component {
  state = {
    revealed: false
  };
  reveal = () => {
    this.setState({ revealed: true });
  };
  render() {
    return (
      <Waypoint onEnter={this.reveal}>
        <Revealable show={this.state.revealed}>
          {this.props.children}
        </Revealable>
      </Waypoint>
    );
  }
}

const SlidingUp = styled("div")`
  opacity: ${({ show }) => (show ? "100" : "0")};
  transform: ${({ show }) => (show ? "translate(0,100px)" : "translate(0,0)")};
  transition: opacity ease-out 0.5s, transform cubic-bezier(0, 0, 0.58, 1) 1s;`;

class SlideUp extends Component {
  state = {
    revealed: false
  };
  reveal = () => {
    this.setState({ revealed: true });
  };
  render() {
    return (
      <Waypoint onEnter={this.reveal}>
        <SlidingUp show={this.state.revealed}>
          {this.props.children}
        </SlidingUp>
      </Waypoint>
    );
  }
}

const DevilishDetailsPage = () => (
    <section>
    <Helmet title="Celebrating Mastery" />
                  <div className="mastery-nav">
                    <Link to="/celebrating-mastery" className="mastery-nav-link allegre"><img className="img-responsive" src={require('../../images/_stories/illustration_passion.png')} /><span className="mastery-nav-link-text">DEVILISH <span className="red">PASSION</span></span></Link>
                    <Link to="/celebrating-mastery/devilish-tenacity" className="mastery-nav-link allegre"><img className="img-responsive" src={require('../../images/_stories/illustration_tenacity.png')} /><span className="mastery-nav-link-text">DEVILISH <span className="red">TENACITY</span></span></Link>
                    <Link to="/celebrating-mastery/heavenly-pioneering" className="mastery-nav-link allegre"><img className="img-responsive" src={require('../../images/_stories/illustration_pioneering.png')} /><span className="mastery-nav-link-text">HEAVENLY <span className="red">PIONEERING</span></span></Link>
                    <Link to="/celebrating-mastery/heavenly-patience" className="mastery-nav-link allegre"><img className="img-responsive" src={require('../../images/_stories/illustration_patience.png')} /><span className="mastery-nav-link-text">HEAVENLY <span className="red">PATIENCE</span></span></Link> 
                    <Link to="/celebrating-mastery/heavenly-ritual" className="mastery-nav-link allegre"><img className="img-responsive" src={require('../../images/_stories/illustration_ritual.png')} /><span className="mastery-nav-link-text">HEAVENLY <span className="red">RITUAL</span></span></Link>
                    <Link to="/celebrating-mastery/devilish-details" className="mastery-nav-link allegre active"><img className="img-responsive" src={require('../../images/_stories/illustration_details.png')} /><span className="mastery-nav-link-text">DEVILISH <span className="red">DETAILS</span></span></Link>  
                  </div>
          {/*DETAILS*/}
          <div className="mastery-block">
              <div className="mastery-block-header">
                <div className="grid-xl container">
                  <div className="columns">
                    <div className="column col-4 col-sm-12"><img className="img-responsive" src={require('../../images/_stories/illustration_details.png')} /></div>
                    <div className="column col-6 col-sm-12">
                      <h1 className="allegre">DEVILISH <span className="red">DETAILS</span></h1>
                      <h4>悪魔は細部に宿る</h4>
                       <p>デュベルグラスの底に刻まれた“D”の文字は、単なるDUVELの頭文字ではない。実はグラス底に文字を刻むことによって炭酸の発泡スピードを遅らせ、より長くクリーミーな泡を楽しむための工夫なのだ。この完璧なゴールデン・エールを、完璧な状態で味わってもらうために。我々はあらゆる細部まで、悪魔のように目を光らせている。</p>
                    </div>
                  </div>
                </div>
            </div>
            <div className="mastery-block-body relative">
               <img className="mastery-big-d" src={require('../../images/D_logo.png')} />
            <div className="grid-xl container">
                  <div className="columns">
                      <div className="column col-6 col-md-12">
                      <div className="mastery-block-text"><h4 className="red">デュベルの“D”は、ディテールの“D”</h4>
                       <p>デュベルはディテールに富んだビールだ。グラスの底に刻まれた“D”の文字はその一角。たとえば、ボトルのフロントラベルをじっくりと眺めたことがあるだろうか？デュベルのロゴの上には、アイコニックなデュベルグラスをデザインした紋章。下部にうっすらと見えるのは、大麦とホップの花で飾られたアントワープ州の紋章だ。ちなみに、1万本に1本の確率で、ロゴ上の紋章に天使と悪魔が紛れ込んでいるのはここだけの話。</p>
                        </div>                                                        
                       <div className="video-wrapper">
        <ReactPlayer 
          className='react-player'
          url='https://www.youtube.com/watch?v=4kgk2zNUfLs'
          width='90%'
          height='90%'
        />
      </div>
        <img className="img-responsive img-60" src={require('../../images/_stories/_details/details_label.jpg')} />
                      
                      </div>
                      
                      <div className="column col-6 col-md-12">
                       <img className="img-responsive img-90" src={require('../../images/_stories/_details/details_glass.jpg')} />
                        
                    </div>
                    <div className="mastery-block-img-footer">                                                     
                    <img className="img-responsive" src={require('../../images/_stories/illustration_details.png')} />
                  </div></div>
             </div>
            </div>
        </div>
    </section>
  
)

export default DevilishDetailsPage



// WEBPACK FOOTER //
// ./src/pages/celebrating-mastery/devilish-details.js